import { useId } from 'react';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Renders the tenant's custom logo if uploaded, falling back to the
 * marca de Grooming ERP: huella + tijeras.
 */
export function GroomingProLogo({ className }: { className?: string }) {
  const tenantLogo = useAuthStore((s) => s.tenant?.logoUrl);
  // El id del degradado tiene que ser único por instancia. Cuando el logo
  // aparece dos veces en la misma página —el login lo pinta en el panel de
  // la izquierda y otra vez arriba para móvil— dos <linearGradient id="ppg">
  // colisionan: `url(#ppg)` resuelve contra el primero del documento, y si
  // ese está oculto el segundo se queda sin relleno. Se veía como un logo
  // invisible en móvil.
  const gradId = useId();
  if (tenantLogo) {
    return (
      <img
        src={tenantLogo}
        alt="Logo"
        className={cn('h-8 w-8 rounded-lg object-contain', className)}
      />
    );
  }
  return (
    <svg viewBox="0 0 64 64" fill="none" className={cn('h-8 w-8', className)} aria-hidden>
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#10b981" />
          <stop offset="100%" stopColor="#2dd4bf" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill={`url(#${gradId})`} />
      <g fill="#fff">
        <circle cx="20" cy="22" r="4" />
        <circle cx="32" cy="18" r="4" />
        <circle cx="44" cy="22" r="4" />
        <circle cx="14" cy="34" r="3.5" />
        <circle cx="50" cy="34" r="3.5" />
        <path d="M32 30 c-8 0 -14 6 -14 12 0 4 3 7 7 7 2 0 4 -1 7 -1 2 0 4 1 7 1 4 0 7 -3 7 -7 0 -6 -6 -12 -14 -12z" />
      </g>
    </svg>
  );
}

export function GroomingProWordmark({ className }: { className?: string }) {
  const tenant = useAuthStore((s) => s.tenant);
  return (
    <div className={cn('flex items-center gap-2 min-w-0', className)}>
      <GroomingProLogo className="h-8 w-8 shrink-0" />
      {tenant?.logoUrl ? (
        <span className="truncate font-display text-sm font-semibold tracking-tight">
          {tenant.name}
        </span>
      ) : (
        <span className="font-display text-xl font-bold tracking-tight">
          Grooming <span className="text-primary">ERP</span>
        </span>
      )}
    </div>
  );
}
